import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { GFImageChoice } from "@components/forms/gf-field-types"
import { GravityFormsFieldState } from "eddev/integrations/gravityforms"
import { useId } from "react"

export function RadioGroup(props: GravityFormsFieldState<string, { choices: GFImageChoice[] }>) {
  const group = useId()

  return (
    <div className={`checkbox-group ${props.type === "image_choice" ? `flex flex-row gap-4 flex-wrap` : ``}`}>
      {props.choices.map((choice, index) => (
        <Radio
          file_url={choice.file_url}
          key={index}
          label={choice.text}
          checked={props.value === choice.value}
          onCheckedChange={() => props.set(choice.value)}
          name={group}
        />
      ))}
    </div>
  )
}

type Props = {
  onCheckedChange: () => void
  checked: boolean
  label: string
  name: string
  file_url?: string
}

export function Radio(props: Props) {
  const id = useId()
  return (
    <>
      {props.file_url ? (
        <div className="flex items-center gap-4 py-2 w-[calc((100%-(var(--spacing-4)*1))*(1/2))] md:w-[calc((100%-(var(--spacing-4)*2))*(1/3))]">
          <input
            type="radio"
            name={props.name}
            aria-label={props.label}
            checked={props.checked}
            id={id}
            onChange={(e) => {
              if (e.target.checked) props.onCheckedChange()
            }}
            className="hidden [&:checked+label>div>div>div]:flex"
          />

          <label
            htmlFor={id}
            className="type-label-m text-text cursor-pointer flex items-center gap-4 flex-col w-full p-5 bg-bgAlt rounded-md"
          >
            <ResponsiveImage mediaItemUrl={props.file_url} aspect={1} className="rounded-sm overflow-hidden w-full" />
            <div className="flex w-full gap-4">
              <div className="w-5 h-5 flex items-center justify-center border rounded-full">
                <div className="w-3 h-3 hidden bg-text rounded-full" />
              </div>
              <span dangerouslySetInnerHTML={{ __html: props.label }} />
            </div>
          </label>
        </div>
      ) : (
        <div className="flex items-center gap-4 py-2">
          <input
            type="radio"
            name={props.name}
            aria-label={props.label}
            checked={props.checked}
            id={id}
            onChange={(e) => {
              if (e.target.checked) props.onCheckedChange()
            }}
            className="hidden [&:checked+label>div>div]:flex"
          />

          <label htmlFor={id} className="type-label-m text-text cursor-pointer flex items-center gap-4 py-2">
            <div className="w-5 h-5 flex items-center justify-center border rounded-full">
              <div className="w-3 h-3 hidden bg-text rounded-full" />
            </div>
            <span dangerouslySetInnerHTML={{ __html: props.label }} />
          </label>
        </div>
      )}
    </>
  )
}
